import { Check } from 'lucide-react';
import { cn } from '@/utils';

export function FilterOptionCheckBadge() {
	return (
		<span className="absolute right-3 flex size-4 shrink-0 items-center justify-center rounded-full bg-[#DCE3F9]">
			<Check className="size-2.5 text-[#5583F6]" strokeWidth={2.5} />
		</span>
	);
}

interface FilterOptionRowProps {
	label: string;
	selected: boolean;
	onClick: () => void;
	height?: 'h-12' | 'h-14';
	divider?: boolean;
}

export function FilterOptionRow({
	label,
	selected,
	onClick,
	height = 'h-12',
	divider = false,
}: FilterOptionRowProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={cn(
				'relative flex w-full items-center px-3 py-1.5 text-left',
				height,
				divider && 'border-b-[0.5px] border-solid border-[#E5E5E5]',
				selected ? 'bg-[#EEF2FF]' : 'bg-white'
			)}
		>
			<span className="font-['DM_Sans'] text-[14px] font-medium leading-5 tracking-[-0.364px] text-[#474747]">
				{label}
			</span>
			{selected && <FilterOptionCheckBadge />}
		</button>
	);
}
